import React from 'react';
import {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifSearch from '@ey/motif-react-wrapper/Search';
import MotifButton from '@ey/motif-react-wrapper/Button';
import {
	pagingOptions,
	reportFormateType,
	currentResource,
	labels
} from '../../../util/uiconstants';
import AccessDeniedMessage from '../../Common/AccessDeniedMessage/AccessDeniedMessage';
import DocumentsTable from './documentstable/documentstable';
import {
	getAdminEngagementDocuments,
	resetAdminEngagementDocuments
} from '../../../actions/admin/documentsactions';
import Pagination from '../../Common/Pagination/PaginationMotif';
import {getMeCall} from '../../../actions/admin/mepermissionsactions';
import styled from 'styled-components';
import env from '../../../util/env';
import Loader from '../../Common/Loaders/loadingindicator';
import {downloadReport} from '../../../actions/admin/reportaction';
import moment from 'moment';
import Toast from '../../Common/Toast/Toast';
import {getLocalizedAPIError} from '../common/util';
import {clearErrors} from '../../../actions/erroractions';
import {setIsModalOpen} from '../../../actions/modalstateactions';
import {MotifIcon} from '@ey-xd/motif-react';
import {IconoirCustomExport} from '@ey-xd/motif-icon';

const Wrapper = styled.section`
	padding-top: var(--spacing-xx-large);
	.toastMessage {
		width: 100% !important;
		position: relative;
		.motif-toast {
			position: absolute;
			z-index: 9999;
		}
	}

	.loadingstyle {
		position: absolute;
		top: 50%;
		left: 50%;
	}

	.documentaddon {
		width: 100%;
		padding: var(--spacing-x-large) 0 var(--spacing-large) 0;
		display: flex;

		.search {
			display: inline-block;
			padding-right: var(--spacing-large);
			.canvas-core-search {
				width: var(--px-250);
			}
		}
	}

	.totaldocument {
		margin-right: auto;
		display: inline-block;
		padding: var(--spacing-x-large) 0;
		.totaldocument {
			margin-right: var(--px-5);
		}
	}

	.export {
		display: flex;
	}

	.fieldholder {
		width: 100%;
		display: flex;
		.engid {
			width: 100%;
			display: flex;

			.wrapper {
				width: var(--px-320);
				display: inline-block;
				margin-right: var(--spacing-large);
			}

			.motif-error-message {
				margin-top: var(--px-5);
				svg {
					width: var(--px-18);
					height: var(--px-18);
				}
			}
			.getdocuments {
				display: flex;
				button {
					margin-right: var(--px-12);
				}
			}
		}
	}

	.pagerholder {
		width: calc(100vw - var(--px-80));
		margin: 0 auto;
		max-width: 2048px;
		display: flex;
		padding: var(--spacing-x-large) 0;
	}
`;

export default function DocumentsBase() {
	const userPermissions = useSelector((store) => store.userPermissions);
	const documents = useSelector((store) => store.adminEngagementDocumentsList);
	const [hasClickedSearch, setHasClickedSearch] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [isMeCallSent, setIsMeCallSent] = useState(false);
	const [showRequiredValidationMessage, setShowRequiredEngIdValidationMessage] =
		useState(false);
	const [
		showInvalidEngIdValidationMessage,
		setShowInvalidEngIdValidationMessage] = useState(false);
	const [optionPerPage, setOptionPerPage] = useState(pagingOptions.options[0]);
	const [page, setPage] = useState(1);
	const [totalPages, setTotalPages] = useState();
	const [engIdSearchText, setEngIdSearchText] = useState('');
	const [docIdSearchText, setDocIdSearchText] = useState('');
	const [engIdToSearch, setEngIdToSearch] = useState('');
	const [docIdToSearch, setDocIdToSearch] = useState('');
	const [errorMessage, setErrorMessage] = useState(false);

	const dispatch = useDispatch();

	useEffect(() => {
		if (engIdSearchText.trim().length <= 0) {
			setDocIdSearchText('');
		}
	}, [engIdSearchText]);

	useEffect(() => {
		dispatch(resetAdminEngagementDocuments()).then(() =>
			dispatch(getMeCall()).then(() => setIsMeCallSent(true))
		);
	}, []);

	useEffect(() => {
		if (hasClickedSearch) {
			setShowRequiredEngIdValidationMessage(true);
		}
	}, [hasClickedSearch]);

	useEffect(() => {
		if (hasClickedSearch) {
			getDocumentsList();
		}
	}, [optionPerPage, page, engIdToSearch, docIdToSearch, isMeCallSent]);

	useEffect(() => {
		if (documents) {
			setTotalPages(documents.pages);
		}
	}, [documents]);

	const downloadDocuments = () => {
		let engId = engIdSearchText?.trim();
		if (!isValidEngId(engId)) {
			return;
		}

		setIsLoading(true);
		let documentReportUrl =
			env.getURL('serviceUrlV2') +
			`admin/engagements/${engId}/documents?all=true`;

		var dateTime = moment(new Date()).format('MM-DD-YYYY-HH-mm-ss');
		dispatch(
			downloadReport(
				documentReportUrl,
				`DocumentDetails_${engId}_${dateTime}.${reportFormateType.xlsx}`
			)
		).finally(() => {
			setIsLoading(false);
		});
	};

	const clearError = (isModelOpen) => {
		dispatch(clearErrors()).then(() => {
			dispatch(setIsModalOpen(isModelOpen));
		});
	};

	useEffect(() => {
		clearError(true);
	}, []);
	const getDocumentsList = () => {
		let docIdQuerySearch = '';
		let docId = docIdSearchText?.trim();
		if (docId?.length > 0) {
			docIdQuerySearch = `&documentId=${docId}`;
		}

		let engId = engIdSearchText?.trim();
		if (!isValidEngId(engId)) {
			return;
		}

		setIsLoading(true);
		let engDocumentsListUrl =
			env.getURL('serviceUrlV2') +
			`admin/engagements/${engId}/documents?page=${page}&pageSize=${optionPerPage}${docIdQuerySearch}`;

		dispatch(getAdminEngagementDocuments(engDocumentsListUrl))
			.catch((e) => {
				setErrorMessage(getLocalizedAPIError(e));
				setHasClickedSearch(false);
				clearError(true);
			})
			.finally(() => {
				clearError(true);
				setIsLoading(false);
			});
	};

	const isValidEngId = (engId) => {
		if (!engId || engId.length <= 0) {
			setHasClickedSearch(false);
			setShowRequiredEngIdValidationMessage(true);
			return false;
		}

		if (!Number(engId)) {
			setHasClickedSearch(false);
			setShowInvalidEngIdValidationMessage(true);
			return false;
		}

		return true;
	};

	useEffect(() => {}, [engIdSearchText]);

	function onGetResultButton() {
		setPage(1);
		setOptionPerPage(pagingOptions.options[0]);
		setHasClickedSearch(true);
		setEngIdToSearch(engIdSearchText);
		setDocIdToSearch(docIdSearchText);
	}

	const resetAllData = () => {
		setHasClickedSearch(false);
		setShowInvalidEngIdValidationMessage(false);
		setShowRequiredEngIdValidationMessage(false);
		setEngIdSearchText('');
		setDocIdSearchText('');
		setEngIdToSearch('');
		setDocIdToSearch('');
		setPage(1);
		setOptionPerPage(pagingOptions.options[0]);
		dispatch(resetAdminEngagementDocuments());
	};

	function hasAdminDocumentsPermission() {
		let documentsPermission = userPermissions?.permissions;
		return documentsPermission && documentsPermission?.canAccessDocuments;
	}

	const onDocIdSearchClick = () => {
		setPage(1);
		setOptionPerPage(pagingOptions.options[0]);
		setHasClickedSearch(true);
		setDocIdToSearch(docIdSearchText);
	};

	const paginationHandler = (value) => {
		if (page !== value && page > 0) {
			setPage(value);
		}
	};

	const handlerOptionPage = (value) => {
		if (value !== optionPerPage) {
			setOptionPerPage(value);
			setPage(1);
		}
	};

	return (
		<Wrapper className="wrapper">
			{errorMessage && errorMessage.length > 0 && (
				<section className="mainResponsiveWrapper">
					<section className="toastMessage">
						<Toast variant="error" onClose={() => setErrorMessage(false)}>
							{errorMessage}
						</Toast>
					</section>
				</section>
			)}
			{hasAdminDocumentsPermission() ? (
				<section>
					<section className="mainResponsiveWrapper">
						<section className="fieldholder">
							<section className="engid">
								<section className="wrapper">
									<MotifFormField>
										<MotifSearch
											value={engIdSearchText}
											title={engIdSearchText}
											clearButtonTitle={labels.clear}
											onChange={(event) => {
												setEngIdSearchText(event.target.value);
												setShowInvalidEngIdValidationMessage(false);
											}}
											onEnter={onGetResultButton}
											placeholder={labels.engagementID}
											onClear={() => setEngIdSearchText('')}
										/>
										{engIdSearchText.trim().length == 0 &&
										showRequiredValidationMessage ? (
											<MotifErrorMessage>
												{labels.requiredField}
											</MotifErrorMessage>
										) : (
											<></>
										)}
										{showInvalidEngIdValidationMessage ? (
											<MotifErrorMessage>
												{labels.adminModuleinvalidEngagementId}
											</MotifErrorMessage>
										) : (
											<></>
										)}
									</MotifFormField>
								</section>
								<section className="wrapper">
									<MotifFormField>
										<MotifSearch
											placeholder={labels.docListDocIdSearchLabel}
											value={docIdSearchText}
											onChange={(e) => setDocIdSearchText(e.target.value)}
											onSearchButtonClick={onDocIdSearchClick}
											onClear={() => setDocIdSearchText('')}
											onEnter={onDocIdSearchClick}
											clearHoverText={labels.clear}
											disabled={engIdSearchText?.trim().length <= 0}
											clearButtonTitle={labels.clear}
										/>
									</MotifFormField>
								</section>
								<section>
									<section className="getdocuments">
										<MotifButton
											aria-label="getdocuments"
											variant="primary"
											size="small"
											onClick={onGetResultButton}
										>
											{labels.getDocuments}
										</MotifButton>
										<MotifButton
											aria-label="cleardocuments"
											variant="secondary"
											size="small"
											disabled={!documents.totalEntityCount}
											onClick={resetAllData}
										>
											{labels.clearResults}
										</MotifButton>
									</section>
								</section>
							</section>
							<section className="export">
								<MotifButton
									aria-label="import-export-iconer"
									variant="text-alt"
									disabled={false}
									onClick={() => {
										downloadDocuments();
									}}
								>
									<MotifIcon
										className="icon-container"
										src={IconoirCustomExport}
										size="20"
									/>
									{labels.docListExportBtn}
								</MotifButton>
							</section>
						</section>
						{isLoading ? (
							<Loader show view="blockView" styleName="loadingstyle" />
						) : (
							<section>
								{documents?.data ? (
									<section className="totaldocument motif-body1-default-regular">
										{labels.docListTotalDocuments}
										<span className="motif-body1-default-light">
											{documents.totalEntityCount}
										</span>
									</section>
								) : (
									<></>
								)}
								<section className="tableholder">
									{documents?.data ? (
										documents.totalEntityCount > 0 ? (
											<section>
												<DocumentsTable data={documents.data} />
												<section className="pagerholder">
													<Pagination
														styleName="document-paging mainResponsiveWrapper"
														options={pagingOptions.options}
														pageSize={optionPerPage}
														showText={currentResource.common.pagination.show}
														onPageSizeChange={(pageSize) => {
															handlerOptionPage(pageSize);
														}}
														totalPages={totalPages}
														currentPage={page}
														onPageChange={(pageNumber) => {
															paginationHandler(pageNumber);
														}}
													/>
												</section>
											</section>
										) : (
											<section className="norecord">
												{labels.noResultsFound}
											</section>
										)
									) : (
										<></>
									)}
								</section>
							</section>
						)}
					</section>
				</section>
			) : (
				<section className="message mainResponsiveWrapper">
					<AccessDeniedMessage
						permissionMesage={labels.insufficientPermission}
					/>
				</section>
			)}
		</Wrapper>
	);
}
